import { render } from "./DocumentiUtili.vue?vue&type=template&id=abc24642"
import script from "./DocumentiUtili.vue?vue&type=script&lang=js"
export * from "./DocumentiUtili.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__